module.exports = __webpack_public_path__ + "static/media/google-store-download-fr.a0726c7b.png";